import React from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';

import { history } from 'containers/App';
import LocalisedMessage from 'components/Common/LocalisedMessage';

import ErrorPage from 'components/Errors/ErrorPage';

const ServerError = ({ code, message, titleTextId }) => <ErrorPage title="Server Error" titleTextId={ titleTextId } type="server" showButton onButtonClick={ () => history.go(-1) }>
  <p><LocalisedMessage id={ message } /></p>
  <p className="cp-primary"><b>{ code != null ? code : 500 }</b></p>
  <LocalisedMessage id="server.content" />
</ErrorPage>;

ServerError.propTypes = {
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  message: PropTypes.string,
  titleTextId: PropTypes.string
};

ServerError.defaultProps = {
  code: 500,
  message: 'server.defaultMessage',
  titleTextId: 'server.title'
};

export default injectIntl(ServerError);
